import { mapState } from 'vuex';
import { formatDate, replaceZero, replaceLastZero } from '@/utils';
import baseUrl from '@/common/config/index.js';
import templateApi from '@/api/template';
export default {
  data() {
    return {
      // 添加baseUrl列表导出等地方用到
      baseUrl: baseUrl,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo.userInfo,
      lang: (state) => state.lang.language,
      dictList: (state) => state.dict.dictList,
      dictListMap: (state) => state.dict.dictListMap,
    }),
    // 是否为物贸
    isWuMaoAccount() {
      console.log(
        this.userInfo.businessGroup,
        '当前的账号类型',
        ['物贸', '国贸'].includes(this.userInfo?.businessGroup)
      );
      return ['物贸', '国贸'].includes(this.userInfo?.businessGroup);
    },
  },
  methods: {
    replaceLastZeroStr(number) {
      return replaceLastZero(number, this.isWuMaoAccount);
    },
    replaceZeroStr(number) {
      return replaceZero(number, this.isWuMaoAccount);
    },
    collectionQueryField(filedList) {
      const queryObj = {};
      for (const item of filedList) {
        queryObj[item.prop] = '';
      }
      return queryObj;
    },
    formatDateStr(item, isDue = false) {
      return formatDate(item, isDue);
    },
    async downExcelTemplate(fileKey) {
      if (!fileKey) {
        this.$message.error('请传递模板');
        return;
      }
      const fileMap = {
        '01': 'templates/主数据管理/供应商发货指令导入模板.xlsx',
        '02': 'templates/主数据管理/投送人合同批量导入模板.xlsx',
        '03': 'templates/主数据管理/投送人主数据导入模板.xlsx',
        '04': 'templates/财务管理/收款登记模板.xlsx',
        '05': 'templates/财务管理/付款申请导入模板.xlsx',
        '06': 'templates/库存管理/销售提单导入模板.xlsx',
        '07': 'templates/物业管理/电表批量导入模板.xlsx',
        '08': 'templates/物业管理/电表抄表管理批量导入模板.xlsx',
        '09': 'templates/多式联运/普通公路运输导入模板.xlsx',
        '010': 'templates/物业管理/水表抄表管理批量导入模板.xlsx',
        '011': 'templates/物业管理/水表批量导入模板.xlsx',
        '012': 'templates/库存管理/销售提单导入模板-物贸.xlsx',
        '013': 'templates/主数据管理/供应商发货指令导入模板-物贸.xlsx',
        '014': 'templates/统计报表/期初余额导入模板.xlsx',
        '091': 'templates/多式联运/集卡运输服务导入模板.xlsx',
        '092': 'templates/结算管理/多式联运对账模板.xlsx',
        '093': 'templates/结算管理/应收费用清单-园区仓储导入模板.xlsx',
        '094': 'templates/多式联运/线路主数据导入模板.xlsx',
        '095': 'templates/多式联运/运输货物导入模板.xlsx',
        '096': 'templates/多式联运/多联项目服务询报价导入模板.xlsx',
        '097': 'templates/多式联运/多联合同服务计费规则导入模板.xlsx',
        '098': 'templates/物业管理/减免信息导入模板.xlsx',
        '099': 'templates/多式联运/多联项目合同线路信息导入模板.xlsx',
        100: 'templates/主数据管理/商品导入模板.xlsx',
        101: 'templates/资金中心/应收票据导入模板.xlsx',
        102: 'templates/主数据管理/商品属性导入模板(产地、材质、厂商、类目).xlsx',
        103: 'templates/主数据管理/商品属性导入模板(规格).xlsx',
        104: 'templates/主数据管理/商品属性导入模板(包装).xlsx',
        105: 'templates/主数据管理/供货明细表.xlsx',
        106: 'templates/主数据管理/投送人信息补充（证件信息）.xlsx',
        107: 'templates/结算管理/后补结算导入表.xlsx',
        108: 'templates/供应商发货指令/投送人供货明细导入模板.xlsx',
        109: 'templates/销售提单/对钢厂出库供货明细表模板.xlsx',
        110: 'templates/采购合同/投送人合同批量导入模板.xlsx',
      };
      const { data } = await this.$axios.post(templateApi.DOWN_EXCEL_TEMPLATE_API, {
        fileKey: fileMap[fileKey],
      });
      if (data.code === 0) {
        window.location.href = data.data;
        this.$message.success('模板下载成功');
      } else {
        this.$message.error('模板下载失败');
      }
    },
    // 获取token
    async getOaTokenApi() {
      const {
        data: { code, data },
      } = await this.$axios.get(
        `/maindata/sso/getToken?loginId=${
          this.userInfo.oaLoginId || this.userInfo.userInfo.oaLoginId
        }`
      );
      if (code == 0) {
        return data;
      } else {
        this.$message.error('获取oa的token失败');
      }
    },
    // 跳转oa
    async goOaLink(oaUrl) {
      const token = await this.getOaTokenApi();
      if (token) {
        const url = `${oaUrl}&ssoToken=${token}`;
        window.open(url, '_blank');
      }
    },
  },
};
